import { Box, Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import Field from "components/Input/Field";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { FiltrosAdicionaisProps } from "./../FiltrosAdicionais";
import SelectableButton from "components/Button/SelectableButton";
import colors from "resources/theme/colors";
import SelectCentroDeCusto from "../../../../../../../../../components/Input/SelectCentroDeCusto/index";

function FiltrosAdicionaisMovimentacaoFinanceira({
  index,
  control,
  item,
  setValue,
}: FiltrosAdicionaisProps) {
  const { tenant } = useCurrentTenant();

  return (
    <Flex flexDir="column">
      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.search`}
            label="Busca"
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.categoriasFinanceirasIds`}
            label="Contas categorias"
            render={({ field }) => (
              <SelectContaCategoria {...field} allowClear />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contasBancariasIds`}
            label="Contas bancárias"
            render={({ field }) => (
              <SelectContaBancaria {...field} mode="multiple" allowClear />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.unidadeId`}
            label="Unidade"
            render={({ field }) => (
              <SelectUnidade tenantId={tenant.id} {...field} allowClear />
            )}
          />
        </Box>

        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.pessoaId`}
            label="Devedor/Pagador"
            render={({ field }) => (
              <SelectPessoas
                tipoEntidades={[TipoEntidadeEnum.Condomino]}
                unidadeId={item?.parametros?.filtrosAdicionais?.unidadeId}
                allowClear
                {...field}
              />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.centrosDeCustoIds`}
            label="Centros de custo"
            render={({ field }) => (
              <SelectCentroDeCusto mode="multiple" {...field} />
            )}
          />
        </Box>
      </Box>

      <Flex gridGap={4} alignItems="center">
        <Box>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.conciliado`}
            render={({ field }) => (
              <SelectableButton
                selected={
                  item.parametros?.filtrosAdicionais?.conciliado === true
                }
                onClick={() => {
                  field.onChange(true);
                  setValue(
                    `items.${index}.parametros.filtrosAdicionais.naoConciliado`,
                    undefined
                  );
                }}
                onUnselect={() => field.onChange(undefined)}
                rounded="full"
                selectedColor={colors.green500}
                fontSize="14px"
              >
                Conciliado
              </SelectableButton>
            )}
          />
        </Box>

        <Box>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.naoConciliado`}
            render={({ field }) => (
              <SelectableButton
                selected={
                  item.parametros?.filtrosAdicionais?.naoConciliado === true
                }
                onClick={() => {
                  field.onChange(true);
                  setValue(
                    `items.${index}.parametros.filtrosAdicionais.conciliado`,
                    undefined
                  );
                }}
                onUnselect={() => field.onChange(undefined)}
                rounded="full"
                selectedColor={colors.yellow}
                fontSize="14px"
              >
                Não conciliado
              </SelectableButton>
            )}
          />
        </Box>
      </Flex>
    </Flex>
  );
}

export default FiltrosAdicionaisMovimentacaoFinanceira;
